import { Visibility, VisibilityOff } from "@material-ui/icons";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { changeForgotPassword } from "../../services/forgotPassword";

const VerifyTokenAndPassword = ({
  register,
  errors,
  handleSubmit,
  currentUserId,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const param = {
        userId: currentUserId,
        resetCode: data?.token,
        newPassword: window.btoa(data?.password?.trim()),
        confirmPassword: window.btoa(data?.confirm_password?.trim()),
      };

      const response = await changeForgotPassword(baseUrl, param);

      if (response?.messageCode === 6) {
        showNotification(
          "Success",
          response?.message ?? "Password Updated Successfully.",
          "success"
        );
        navigate("/");
      } else {
        showNotification(
          "Error",
          response?.message ?? "Failed To Reset Password."
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Reset Password");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Grid container>
        <Grid item xs={12} mt={7} px={3}>
          <TextField
            sx={{ mb: 4 }}
            margin="normal"
            className="signinText"
            required
            fullWidth
            name="token"
            label="Confirmation Code"
            type={"text"}
            {...register("token")}
            error={Boolean(errors?.token)}
            helperText={errors?.token?.message}
          />
          <TextField
            sx={{ mb: 4 }}
            margin="normal"
            className="signinText"
            required
            fullWidth
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            {...register("password")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setShowPassword((prevValue) => !prevValue);
                    }}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(errors?.password)}
            helperText={errors?.password?.message}
          />
          <TextField
            sx={{ mb: 4 }}
            margin="normal"
            className="signinText"
            required
            fullWidth
            name="confirm_password"
            label="Confirm Password"
            type={showCPassword ? "text" : "password"}
            {...register("confirm_password")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setShowCPassword((prevValue) => !prevValue);
                    }}
                  >
                    {showCPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(errors?.confirm_password)}
            helperText={errors?.confirm_password?.message}
          />
          <Button
            type="button"
            fullWidth
            size="large"
            variant="contained"
            sx={{ mt: 3, mb: 2, color: "white" }}
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>
          <Grid container mt={2}>
            <Grid item xs={6} sx={{ textAlign: "left" }}></Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              <Link
                component="button"
                color="#003f93"
                variant="body1"
                onClick={() => navigate("/")}
              >
                {"Back to Sign In"}
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default VerifyTokenAndPassword;
